import React, { useRef, useCallback } from "react";
import { useFormContext, useWatch } from "react-hook-form";
import PropTypes from "prop-types";
const SupplierInput = ({ id, onSubmit, disabled }) => {
  const { register, watch, setValue } = useFormContext();

  const fieldPath = `attendance[${id}].supplierCompany`;

  // Watch current value
  const currentValue = watch(fieldPath);

  // Store previous value
  const prevValueRef = useRef(currentValue);

  const handleSupplierCompanyUpdate = useCallback(() => {
    if (prevValueRef.current !== currentValue) {
      
      prevValueRef.current = currentValue;
      onSubmit(id);
    } else {
      // If the value hasn't changed, do nothing
      return;
    }
  }, [currentValue]);

  return (
    <input
      {...register(fieldPath)}
      type="text"
      className="form-control select-option-height"
      defaultValue={currentValue}
      // style={{ width: "150px" }}
      readOnly={watch(`attendance[${id}].isApproved`) || watch(`attendance[${id}].isReviewed`)}
      onBlur={handleSupplierCompanyUpdate}
    />
  );
};

SupplierInput.propTypes = {
  id: PropTypes.number.isRequired,
  onSubmit: PropTypes.func.isRequired,
  disabled : PropTypes.bool.isRequired
};

export default SupplierInput;
